enum SparkWaitlistErrorCode {
  MISSING_SPARK_ID = "MISSING_SPARK_ID",
  INVALID_SPARK_ID = "INVALID_SPARK_ID",
  MISSING_FIELDS = "MISSING_FIELDS",
  AGE_RESTRICTION = "AGE_RESTRICTION",
}
const SparkWaitlistErrorMap: Record<SparkWaitlistErrorCode, string> = {
  [SparkWaitlistErrorCode.MISSING_SPARK_ID]:
    "Something went wrong. Please contact us and reference error code MISSING_SPARK_ID. We will resolve this issue ASAP.",
  [SparkWaitlistErrorCode.INVALID_SPARK_ID]:
    "Something went wrong. Please contact us and reference error code INVALID_SPARK_ID. We will resolve this issue ASAP.",
  [SparkWaitlistErrorCode.MISSING_FIELDS]:
    "Your acocunt is missing information required to join the wait list.",
  [SparkWaitlistErrorCode.AGE_RESTRICTION]:
    "It looks like you don't fall in the age range for this event.",
};
export const getSparkWaitlistErrorMessage = (code?: string) => {
  if (code && code in SparkWaitlistErrorMap) {
    return SparkWaitlistErrorMap[code as SparkWaitlistErrorCode];
  }
  return "Something went wrong. Please contact us and we will resolve this issue ASAP.";
};
